import React, { useState, useEffect } from 'react';
import './blocks/ModernBlocks.css';
import SliderBlock from './blocks/SliderBlock';
import TextImageBlock from './blocks/TextImageBlock';
import FeaturesBlock from './blocks/FeaturesBlock';
import TestimonialsBlock from './blocks/TestimonialsBlock';
import FullBlock from './blocks/FullBlock';
import CTABlock from './blocks/CTABlock';
import AdvancedBlock from './blocks/AdvancedBlock';
import HeroBlock from './blocks/HeroBlock';
import StatsBlock from './blocks/StatsBlock';
import ServicesBlock from './blocks/ServicesBlock';
import ProcessBlock from './blocks/ProcessBlock';
import TechnologiesBlock from './blocks/TechnologiesBlock';
import ImageSliderBlock from './blocks/ImageSliderBlock';
import StoryBlock from './blocks/StoryBlock';
import ValuesBlock from './blocks/ValuesBlock';
import TeamBlock from './blocks/TeamBlock';
import CultureBlock from './blocks/CultureBlock';
import AwardsBlock from './blocks/AwardsBlock';
import CaseStudiesBlock from './blocks/CaseStudiesBlock';
import FAQBlock from './blocks/FAQBlock';
import GalleryBlock from './blocks/GalleryBlock';
import BeforeAfterBlock from './blocks/BeforeAfterBlock';
import TeamShowcaseBlock from './blocks/TeamShowcaseBlock';
import PortfolioBlock from './blocks/PortfolioBlock';
import ImageTextLeftBlock from './blocks/ImageTextLeftBlock';
import TextImageRightBlock from './blocks/TextImageRightBlock';

const AboutPage = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/data/about-page.json')
      .then(response => response.json())
      .then(data => {
        setPageData(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading about page data:', error);
        setLoading(false);
      });
  }, []);

  const renderBlock = (block, index) => {
    if (!block || !block.type) {
      return <div key={index}>Invalid block data</div>;
    }

    try {
      switch (block.type) {
        case 'imageSlider':
          return <ImageSliderBlock key={index} data={block} />;
        case 'hero':
          return <HeroBlock key={index} data={block} />;
        case 'stats':
          return <StatsBlock key={index} data={block} />;
        case 'services':
          return <ServicesBlock key={index} data={block} />;
        case 'process':
          return <ProcessBlock key={index} data={block} />;
        case 'technologies':
          return <TechnologiesBlock key={index} data={block} />;
        case 'story':
          return <StoryBlock key={index} data={block} />;
        case 'values':
          return <ValuesBlock key={index} data={block} />;
        case 'team':
          return <TeamBlock key={index} data={block} />;
        case 'culture':
          return <CultureBlock key={index} data={block} />;
        case 'awards':
          return <AwardsBlock key={index} data={block} />;
        case 'caseStudies':
          return <CaseStudiesBlock key={index} data={block} />;
        case 'faq':
          return <FAQBlock key={index} data={block} />;
        case 'gallery':
          return <GalleryBlock key={index} data={block} />;
        case 'beforeAfter':
          return <BeforeAfterBlock key={index} data={block} />;
        case 'teamShowcase':
          return <TeamShowcaseBlock key={index} data={block} />;
        case 'portfolio':
          return <PortfolioBlock key={index} data={block} />;
        case 'imageTextLeft':
          return <ImageTextLeftBlock key={index} data={block} />;
        case 'textImageRight':
          return <TextImageRightBlock key={index} data={block} />;
        case 'slider':
          return <SliderBlock key={index} data={block} />;
        case 'textImage':
          return <TextImageBlock key={index} data={block} />;
        case 'features':
          return <FeaturesBlock key={index} data={block} />;
        case 'testimonials':
          return <TestimonialsBlock key={index} data={block} />;
        case 'full':
          return <FullBlock key={index} data={block} />;
        case 'cta':
          return <CTABlock key={index} data={block} />;
        case 'advanced':
          return <AdvancedBlock key={index} data={block} />;
        default:
          return <div key={index}>Unknown block type: {block.type}</div>;
      }
    } catch (error) {
      console.error(`Error rendering block ${index}:`, error);
      return <div key={index}>Error rendering block: {block.type}</div>;
    }
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '1.2rem',
        color: '#666'
      }}>
        Loading About Page...
      </div>
    );
  }

  if (!pageData || !pageData.blocks) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '1.2rem',
        color: '#666'
      }}>
        Error loading about page content
      </div>
    );
  }

  return (
    <div className="aboutpage">
      {/* Hero Section */}
      <div className="about-hero">
        <div className="about-hero-container">
          <h1 className="about-hero-title">About Us</h1>
          <p className="about-hero-subtitle">
            For over 15 years, Black Catz Innovations has been the trusted partner for comprehensive security solutions, 
            protecting homes, businesses, and institutions across the region. Learn about our journey, team, values, 
            and commitment to providing cutting-edge security technology.
          </p>
        </div>
      </div>

      {/* Page Content Blocks */}
      {pageData.blocks.map((block, index) => renderBlock(block, index))}
    </div>
  );
};

export default AboutPage; 